import { useState } from "react";
import { useNavigate, useParams } from "react-router";

import { Page } from "@digital-services/shell";
import {
  Button,
  Card,
  Input,
  Typography,
  useAlert
} from "@digital-services/ui";

import { apiUsersRoute, editApiUserRouteOnTab1 } from "@api-users/common";
// import { getRandomApiUser } from "@api-users/part-1-api-user/mocks/api-users.gen";
import { useUpdateApiUser } from "@api-users/part-1-api-user/services/use-update-api-user";

import { useOrganizationContext } from "@hooks/useOrganizationContext";

export const EditApiUserNamePage = () => {
  const navigate = useNavigate();
  const { notifyError, notifySuccess } = useAlert();

  const [newName, setNewName] = useState("");
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const [inProgress, setInProgress] = useState(false);

  const { apiUserId } = useParams();
  const { organization: currentOrganization } = useOrganizationContext();
  const { updateApiUser } = useUpdateApiUser();

  // TEMP
  // const apiUser = getRandomApiUser();

  const onUpdateCallback = async () => {
    setUpdateDisabled(true); // to avoid frequent clicks/POST requests to server
    setInProgress(true);

    const response = await updateApiUser(
      currentOrganization.id,
      apiUserId!,
      newName
    );

    if (response?.isSuccess) {
      notifySuccess({
        header: "API user name has been updated successfully",
        "data-testid": "update-api-user-success"
      });

      navigate(editApiUserRouteOnTab1(apiUserId!));
    } else {
      notifyError({
        header: "Could not update name for API user",
        "data-testid": "update-api-user-error"
      });
    }

    setInProgress(false);
  };

  return (
    <Page title={"Edit API User"}>
      <div className="flex justify-end gap-6">
        <Button
          variant="ghost"
          size="big"
          onClick={() => {
            navigate(apiUsersRoute);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="big"
          disabled={updateDisabled}
          isLoading={inProgress}
          onClick={onUpdateCallback}
        >
          Save
        </Button>
      </div>
      <div className="flex">
        <Card className="w-[50%]">
          <Typography variant="smallTitle">Details</Typography>
          <div className="mt-6">
            <Input
              id={"new-api-user-name"}
              data-testid={"new-api-user-name"}
              label="Name"
              value={newName}
              onChange={e => {
                if (e.target.value?.length > 0) {
                  setUpdateDisabled(false);
                  setNewName(e.target.value);
                }
              }}
            />
          </div>
        </Card>
      </div>
    </Page>
  );
};
